import { render, staticRenderFns } from "./ViewInvoice.vue?vue&type=template&id=898c6ebe&"
import script from "./ViewInvoice.vue?vue&type=script&lang=js&"
export * from "./ViewInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports